/**
 * Booking Services Module
 * Exports all booking management services and factory functions
 */
// Export all service classes
export { BookableResourceService } from './BookableResourceService';
export { BookableResourceTypeService } from './BookableResourceTypeService';
export { BookableResourceStatusService } from './BookableResourceStatusService';
export { BookableResourceImageService } from './BookableResourceImageService';
export { BookableResourceBlockoutService } from './BookableResourceBlockoutService';
export { BookableResourceBlockoutTypeService } from './BookableResourceBlockoutTypeService';
export { BookingService } from './BookingService';
export { BookingStatusService } from './BookingStatusService';
export { BookingLogService } from './BookingLogService';
export { BookingAccessoryService } from './BookingAccessoryService';
export { BookingSettingService } from './BookingSettingService';
// Import for factory function
import { BookableResourceService } from './BookableResourceService';
import { BookableResourceTypeService } from './BookableResourceTypeService';
import { BookableResourceStatusService } from './BookableResourceStatusService';
import { BookableResourceImageService } from './BookableResourceImageService';
import { BookableResourceBlockoutService } from './BookableResourceBlockoutService';
import { BookableResourceBlockoutTypeService } from './BookableResourceBlockoutTypeService';
import { BookingService } from './BookingService';
import { BookingStatusService } from './BookingStatusService';
import { BookingLogService } from './BookingLogService';
import { BookingAccessoryService } from './BookingAccessoryService';
import { BookingSettingService } from './BookingSettingService';
/**
 * Create all booking services with shared configuration
 * @param http - HTTP client instance
 * @param config - Service configuration (servicePath, endpoints)
 * @returns Object containing all booking service instances
 */
export function createBookingServices(http, config) {
    return {
        bookableResource: new BookableResourceService(http, config),
        bookableResourceType: new BookableResourceTypeService(http, config),
        bookableResourceStatus: new BookableResourceStatusService(http, config),
        bookableResourceImage: new BookableResourceImageService(http, config),
        bookableResourceBlockout: new BookableResourceBlockoutService(http, config),
        bookableResourceBlockoutType: new BookableResourceBlockoutTypeService(http, config),
        booking: new BookingService(http, config),
        bookingStatus: new BookingStatusService(http, config),
        bookingLog: new BookingLogService(http, config),
        bookingAccessory: new BookingAccessoryService(http, config),
        bookingSetting: new BookingSettingService(http, config),
    };
}
//# sourceMappingURL=index.js.map